import { render } from "./Slide2.vue?vue&type=template&id=aafe8182&scoped=true"
import script from "./Slide2.vue?vue&type=script&lang=js"
export * from "./Slide2.vue?vue&type=script&lang=js"

import "./Slide2.vue?vue&type=style&index=0&id=aafe8182&lang=scss&scoped=true"
import "./Slide2.vue?vue&type=style&index=1&id=aafe8182&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aafe8182"]])

export default __exports__